const elms = document.querySelectorAll('.faq-item');
elms.forEach((elm) => {
	elm.addEventListener('click', ()=> {
		elm.classList.toggle('expanded');
	});
})
